import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from '../types';

interface AuthState {
  user: User | null;
  token: string | null;
}

const initialState: AuthState = {
  user: null, // Do not store user in local storage
  token: localStorage.getItem('token'),
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials(
      state,
      action: PayloadAction<{ user: User; token: string }>
    ) {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem('token', action.payload.token); // Only store token in local storage
    },
    logout(state) {
      state.user = null;
      state.token = null;
      localStorage.removeItem('token'); // Remove token from local storage
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
